/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ModalNovaSenhaAliases {
  AVATAR_0 = 'avatar-0',
  AVATAR_1 = 'avatar-1',
  BUTTON_CONFIRMAR = 'button-confirmar',
  FIELD_0 = 'field-0',
  FIELD_CONFIRMAR = 'field-confirmar',
  FORM = 'form',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  LAYOUT_0 = 'layout-0',
  LOADER_0 = 'loader-0',
  MODAL_NOVA_SENHA = 'modal-nova-senha',
  PANEL_0 = 'panel-0',
  PANEL_AVISO_FALHA = 'panel-aviso-falha',
  PANEL_AVISO_SUCESSO = 'panel-aviso-sucesso',
  PANEL_FORM = 'panel-form',
  PANEL_LOADER = 'panel-loader',
}
export { ModalNovaSenhaAliases };
